import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import stateCodes from 'constants/stateCodes';
import timezones from 'constants/timezones';
import clientUserRoles from 'constants/clientUserRoles';
import FormInput from 'components/FormInput/index';

const stateCodesOptions = stateCodes.map(code => {
    return {id: code, name: code};
});

const timezoneOptions = timezones.map(zone => {
    return {id: zone, name: zone};
});

const UserFormInputs = ({
    register,
    errors,
    control,
    isUpdateMode = false,
    isCurrentUser = false,
    watch,
    isSystemAdmin = false,
    editingUserRole = null     
}) => {
    // Filter roles based on current user's permissions
    const availableRoles = React.useMemo(() => {
        if (isSystemAdmin) {
            return clientUserRoles; // Can assign any role
        } else {
            return clientUserRoles.filter(role => role !== 'SystemAdmin');
        }
    }, [isSystemAdmin]);
    
    const clientUserRolesOptions = availableRoles.map(role => {
        return {id: role, name: role};
    });
    
    const isRoleDisabled = isUpdateMode && 
                          editingUserRole === 'SystemAdmin' && 
                          !isSystemAdmin;
    // const { data, isLoading, error } = getCustomerFormData();

    // const [parentCustomersKey, setParentCustomersKey] = useState<string>('');

    // if (error || errorCustomers || statesError) {
    //     return <ErrorMessage message="Something went wrong on our end" />;
    // }


    return (
        <>
            {
                isUpdateMode && 
                (<>
                    <FormInput
                        type="hidden"
                        name="id"
                        labelClassName="required"
                        containerClass={'mb-3'}
                        register={register}
                        key="name"
                        errors={errors}
                    />
                    <FormInput
                    type="hidden"
                    name="secureId"
                    labelClassName="required"
                    containerClass={'mb-3'}
                    register={register}
                    key="name"
                    errors={errors}
                />
                </>)
            }
            <Row>
                <Col lg={6}>
                    <FormInput
                        label="Email Address"
                        type="text"
                        name="emailAddress"
                        labelClassName="required"
                        containerClass={'mb-3'}
                        register={register}
                        key="name"
                        errors={errors}
                        disabled={isUpdateMode}
                        validation={{
                            required: {
                                value: true,
                                message: 'EmailAddress is required.'
                            },
                            pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: 'Not a valid email address.',
                            },
                            maxLength: {
                                value: 50,  // Max length of 50 characters
                                message: 'emailAddress cannot exceed 50 characters'
                            },
                        }}
                    />
                </Col>
                <Col lg={4}>
                    {
                        !isCurrentUser &&
                        (<FormInput
                            type="select"
                            label="User Role"
                            labelClassName={'required'}
                            name="role"
                            options={clientUserRolesOptions}
                            control={control}
                            errors={errors}
                            labelKey="name"
                            containerClass={'mb-3'}
                            disabled={isRoleDisabled}
                            validation={{
                                required: "Please select a Role"
                            }}
                            maxMenuHeight={245}
                        />)
                    }
                </Col>
            </Row>
            <h5>General Details</h5>
            <hr />
            <Row>
                <Col lg={6}>
                    <FormInput
                        label="First Name"
                        type="text"
                        name="firstName"
                        labelClassName="required"
                        containerClass={'mb-3'}
                        register={register}
                        key="name"
                        errors={errors}
                        validation={{
                            required: {
                                value: true,
                                message: 'First Name is required.'
                            }
                        }}
                    />
                </Col>
                <Col lg={6}>
                    <FormInput
                            label="Last Name"
                            type="text"
                            name="lastName"
                            labelClassName="required"
                            containerClass={'mb-3'}
                            register={register}
                            key="name"
                            errors={errors}
                            validation={{
                                required: {
                                    value: true,
                                    message: 'Last Name is required.'
                                }
                            }}
                        />
                </Col> 
            </Row>         
            <Row>
                <Col lg={6}>
                    <FormInput
                        label="Address Line 1"
                        type="text"
                        name="address1"
                        containerClass={'mb-3'}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col lg={6}>
                    <FormInput
                        label="Address Line 2"
                        type="text"
                        name="address2"
                        containerClass={'mb-3'}
                        register={register}
                        errors={errors}
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    <FormInput
                        label="City"
                        type="text"
                        labelClassName={''}
                        name="city"
                        containerClass={'mb-3'}
                        register={register}
                        key="city"
                        errors={errors}
                        validation={{
                            required: {
                                value: false,
                                message: 'This field is required.'
                            }
                        }}
                    />
                </Col>
                <Col lg={4}>
                    <FormInput
                        type="select"
                        label="State"
                        name="stateCode"
                        options={stateCodesOptions}
                        control={control}
                        errors={errors}
                        labelKey="name"
                        containerClass={'mb-3'}
                        maxMenuHeight={180}
                    />
                </Col>
                <Col lg={4}>
                    <FormInput
                        type="zipCode"
                        label="Zip"
                        labelClassName={''}
                        name="zipCode"
                        errors={errors}
                        containerClass={'mb-3'}
                        control={control}
                    />
                </Col>
            </Row>
            <Row>
            <Col lg={6}>
                    <FormInput
                        type="phone"
                        label="Phone Number"
                        name="phoneNumber"
                        control={control}
                        errors={errors}
                        containerClass="mb-3"
                        validation={{
                            pattern: {
                                value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                message: 'Please enter a valid phone number'
                            }
                        }}
                    />
                </Col>
                <Col lg={6}>
                    <FormInput
                        type="hidden"
                        label="Timezone"
                        labelClassName={'required'}
                        name="timezone"
                        options={timezoneOptions}
                        control={control}
                        errors={errors}
                        labelKey="name"
                        containerClass={'mb-3'}
                    />
                </Col>
            </Row>

        </>
    );
};

export default UserFormInputs;
